export default "__VITE_ASSET__4P0wKoHr__"